<template>
  <section>
    <div>
      <span>
        <title class="display-inline-block body1">1. Prerequisite</title>
        <pre><strong># (OPTIONAL) </strong>{{
          `If you have an elrepo kernel you may need to run the following:
           sudo yum install --enablerepo=elrepo-kernel install kernel-lt-devel\n
           # Ensure epel-release is installed (needed for dkms)
           sudo yum install epel-release\n
           # Ensure selinux is installed
           sudo yum install container-selinux || # OR \\
           # if the vm cannot resolve the url- downloaded rpm from another machine and copied onto the vm
           wget -P /tmp https://vault.centos.org/7.6.1810/extras/x86_64/Packages/container-selinux-2.68-1.el7.noarch.rpm
           sudo yum install /tmp/container-selinux-2.68-1.el7.noarch.rpm\n
           # Ensure dkms is installed
           sudo yum install dkms\n
           # Ensure dkms build dependencies are installed
           sudo yum install kernel-devel-$(uname -r) kernel-devel make`
        }}</pre>
      </span>
    </div>
    <div>
      <span>
        <title class="display-inline-block body1">2. Download</title>
        <span class="display-inline-block install-button">
          <p
            class="display-block download-instr complete cursor-pointer"
            @click.prevent="downloadPackage"
            v-if="osDownloadProgress.status === 'success'"
          >
            Download Complete!
            <i class="material-icons done">done</i>
          </p>
          <p v-else class="display-block download-instr cursor-pointer" @click.prevent="downloadPackage">
            confluera agent installer
          </p>
          <el-progress
            class="display-block"
            v-if="$_.indexOf(['start', 'loading'], osDownloadProgress.status) > -1"
            :percentage="osDownloadProgress.percentage"
            :show-text="false"
          ></el-progress>
        </span>
      </span>
    </div>
    <div>
      <span>
        <title class="display-inline-block body1">3. Installation</title>
      </span>
      <pre>{{
        `# Extract the tarball with the packages
        tar -xf trailblazer-packages*.tar\n
        cd trailblazer-packages*-rpm\n
        # Install packages with yum
        sudo yum install ./trailblazer-config-*x86_64.rpm
        sudo yum install ./trailblazer-*.x86_64.rpm`
      }}</pre>
    </div>
    <div>
      <span>
        <title class="display-inline-block body1">4. Check</title>
        <p class="display-inline-block">Check if the agent is running using the following command (ctrl-c to exit):</p>
      </span>
      <pre>{{ `journalctl -u trailblazer -fxe` }}</pre>
    </div>
    <div>
      <span>
        <title class="display-inline-block body1">Removal</title>
        <p class="display-inline-block">To remove, issue the following command:</p>
      </span>
      <pre>{{ `sudo yum remove trailblazer trailblazer-config` }}</pre>
    </div>
    <br />
    <br />
    <br />
  </section>
</template>

<script>
import OsInstallInstructions from '@/components/os-template/OsInstallInstructions'
export default {
  name: 'AmazonLinux2Instructions',
  extends: OsInstallInstructions
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/text.css';

title {
  color: var(--denim-700) !important;
  font-weight: bold !important;
}

pre {
  white-space: pre-line;
}

.install-button {
  vertical-align: middle;
}

.download-instr {
  line-height: 28px;
  padding: 4px;
  color: var(--denim-900);
  background-color: var(--denim-50);
  border: 1px solid var(--denim-900);

  &.complete {
    color: var(--shamrock-600);
    background-color: var(--shamrock-50);
    border: 1px solid var(--shamrock-600);
  }

  .done {
    vertical-align: text-bottom;
    margin-left: 25px;
  }
}

img {
  display: block;
  border: 1px solid var(--border-color);
}
</style>



// WEBPACK FOOTER //
// src/components/os-template/AmazonLinux2Instructions.vue